import React, { Component, Fragment } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { ISubScoreData, ITaskEditorProps } from "../../../../../../common/types";

import { setItem, hasItem } from "../../../../../cookie";
import { Checkbox, Range } from "../../../../Form";

import EditorBar, { FlexLeft, FlexRight, Center, Changer, ChangerPopup } from "../../../EditorBar";
import Wrapper from "../../../Wrapper";
import ViewContainer from "../../../ViewContainer";

import messages from "./messages";
import VideoEditor from "./VideoEditor";
import { Line, Point, Progress, Tick } from "../../BarSorting/editor/ScoreEditor/styles";
import Icon from "../../../../../icon";
import { isAvailableStage, stages } from "./utils";
import ScoreEditor from "./ScoreEditor";
import ScoreVideoSync from "./ScoreVideoSync"
import { IState } from "./interfaces";
import { ICheckboxEvent } from "../../../../../types";
import ChangeColor from "../../Common/ChangeColor";

class SubScoreEditor extends Component<ITaskEditorProps, IState> {
    constructor(props: ITaskEditorProps) {
        super(props);
        const { plan, taskIndex } = props;
        const task = plan.tasks[taskIndex];
        // upload
        let stage: IState["stage"] = "youtube-video";

        if (task.data) {
            const data = task.data as ISubScoreData;
            if (data.href) {
                stage = "scores";
            }
            if (data.scores && data.scores.length > 0) {
                stage = "scores-sync";
            }
        }

        let latestStage = stage;
        this.state = {
            stage,
            latestStage,
            openChanger: undefined,
            playable: false,
        }
    }
    popup?: HTMLDivElement;
    componentDidUpdate() {
        const { plan, taskIndex } = this.props;
        const task = plan.tasks[taskIndex];
        let latestStage: IState["stage"] = "youtube-video";
        if (task.data) {
            const data = task.data as ISubScoreData;
            if (data.href) {
                latestStage = "scores";
            }
            if (data.scores && data.scores.length > 0) {
                latestStage = "scores-sync";
            }
        }
        if (latestStage !== this.state.latestStage) {
            this.setState({ latestStage });
        }
    }
    changeOpacity = (val: number) => {
        const { taskIndex, editTask } = this.props;
        editTask({ taskIndex, changingProp: "opacity", val });
    };

    changeOpacityStop = () => {
        const { plan, taskIndex, post } = this.props;
        const { opacity } = plan.tasks[taskIndex].data as ISubScoreData;
        post("subscore-opacity", {
            planId: plan._id,
            index: taskIndex,
            opacity,
        });
    };

    changeOpen = (changer: string) => {
        setTimeout(() => {
            if (this.state.openChanger === changer) {
                window.removeEventListener("click", this.isClickedOutside);
                this.setState({ openChanger: undefined });
            } else {
                this.setState({ openChanger: changer });
                setTimeout(() => {
                    window.addEventListener("click", this.isClickedOutside);
                });
            }
        });
    };
    isClickedOutside = (e: MouseEvent) => {
        if (!this.popup!.contains(e.target as Node)) {
            this.setState({ openChanger: undefined });
            window.removeEventListener("click", this.isClickedOutside);
        }
    };
    changeNotFollowNotes = ({ target: { checked } }: ICheckboxEvent) => {
        const { plan, taskIndex, editTask, post } = this.props;
        editTask({ taskIndex, changingProp: "notFollowNotes", val: !checked });
        post("subscore/not-follow-notes", {
            planId: plan._id,
            index: taskIndex,
            notFollowNotes: !checked,
        });
    }
    componentWillUnmount() {
        window.removeEventListener("click", this.isClickedOutside);
    }
    render() {
        const { stage, openChanger, latestStage } = this.state;
        const { taskIndex, toggleInlineEditor, plan, publicView, viewProps, inlineEditorOpen, playable } = this.props;
        const { formatMessage } = this.props.intl!;
        if (!plan)
            return (
                <div>
                    <FormattedMessage {...messages.loading} />
                </div>
            );
        const data = plan.tasks[taskIndex].data as ISubScoreData;
        return (
            <div>
                {inlineEditorOpen && (
                    <ViewContainer viewProps={viewProps}>
                        <Wrapper>
                            <Progress>
                                {stages(formatMessage).map((st, index) => {
                                    let property = st[0] as IState["stage"];
                                    let isAvailable = isAvailableStage(latestStage, property, formatMessage);
                                    return (
                                        <Fragment key={index}>
                                            <Point
                                                key={index}
                                                className={cn(stage === property && "Active", isAvailable && "Selectable")}
                                                onClick={() => {
                                                    if (isAvailable) {
                                                        this.setState({ stage: property as IState["stage"] });
                                                    }
                                                }}
                                            >
                                                {isAvailable && (
                                                    <Tick>
                                                        <Icon i="tick" />
                                                    </Tick>
                                                )}
                                                <div className={"Label"}>
                                                    {st[1] as string}
                                                    {/* <HelpWrapper>
                                                        <Help>?</Help>
                                                        <HelpDescription
                                                            left={index === stages(formatMessage).length - 1}
                                                            className={"HelpDescription"}
                                                            dangerouslySetInnerHTML={{
                                                                __html: description.slice(
                                                                    starts[(stages(formatMessage)[index][2] as { start: number, end: number }).start],
                                                                    ends[(stages(formatMessage)[index][2] as { start: number, end: number }).end] + 5
                                                                ),
                                                            }}
                                                        ></HelpDescription>
                                                    </HelpWrapper> */}
                                                </div>
                                            </Point>
                                            {index < stages(formatMessage).length - 1 && <Line />}
                                        </Fragment>
                                    );
                                })}
                            </Progress>
                            {stage === "youtube-video" && (
                                <VideoEditor data={data} taskIndex={taskIndex} plan={plan} />
                            )}
                            {stage === "scores" && (
                                <ScoreEditor data={data} taskIndex={taskIndex} plan={plan} />
                            )}
                            {stage === "scores-sync" && (
                                <ScoreVideoSync data={data} taskIndex={taskIndex} plan={plan} />
                            )}
                        </Wrapper>
                    </ViewContainer>
                )}
                {!publicView && (
                    <EditorBar>
                        <FlexLeft>
                            <Changer active={openChanger === "opacity"}>
                                <div
                                    onClick={e => {
                                        e.stopPropagation();
                                        this.changeOpen("opacity");
                                    }}
                                >
                                    <Icon i="duplicate" />
                                </div>
                                {openChanger === "opacity" && (
                                    <ChangerPopup setRef={t => (this.popup = t)}>
                                        <Range
                                            value={data.opacity || 0.5}
                                            onChange={this.changeOpacity}
                                            onStop={this.changeOpacityStop}
                                            min={0.3}
                                            max={1}
                                            step={0.01}
                                            scale={1}
                                            label={<FormattedMessage {...messages.opacity} />}
                                        />
                                    </ChangerPopup>
                                )}
                            </Changer>
                        </FlexLeft>
                        <Center
                            disabled={!playable}
                            onClick={() => {
                                toggleInlineEditor(!inlineEditorOpen);
                                setItem("embedDone", "1", 60 * 60 * 24 * 365, "/");
                            }}
                            className={cn(!(inlineEditorOpen && !playable) && !hasItem("embedDone") && "pulsate")}
                        >
                            {inlineEditorOpen ? (
                                <FormattedMessage {...messages.stopEdit} />
                            ) : (
                                <FormattedMessage {...messages.startEdit} />
                            )}
                        </Center>
                        <FlexRight>
                            <Changer>
                                <Checkbox
                                    dark
                                    label={<FormattedMessage {...messages.followNotes} />}
                                    checked={!data.notFollowNotes}
                                    onChange={this.changeNotFollowNotes}
                                />
                            </Changer>
                            <ChangeColor
                                handleChangeOpen={this.changeOpen}
                                openChanger={openChanger}
                                plan={plan}
                                setPopupRef={t => (this.popup = t)}
                                taskIndex={taskIndex}
                                color={data?.color}
                            />
                        </FlexRight>
                    </EditorBar>
                )}
            </div>
        );
    }
}

export default SubScoreEditor;
